import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import CompactLayout from 'src/layouts/compact';
import AuthGuard from 'src/auth/guard/auth-guard';
export const HomePage = lazy(() => import('src/pages/home'));
export const NotFound = lazy(() => import('src/pages/404'));
export const OrderPage = lazy(() => import('src/pages/order/order'));
export const TransactionSuccess = lazy(() => import('src/pages/order/transaction'));
export const OrderSummary = lazy(() => import('src/pages/order/orderhistory'));

export const mainRoutes = [
  {
    element: (
      <AuthGuard>
        <CompactLayout>
          <Outlet />
        </CompactLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'order', element: <OrderPage /> },
      { path: 'transaction-success', element: <TransactionSuccess /> },
      { path: 'order-summary', element: <OrderSummary /> },
    ],
  },
];